import { IconProps } from "../../types/utils";

const ProfileIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 40}
    height={dimension || 40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.546 30.72L24.9993 28.3333V24.8916C27.986 22.6683 29.9993 18.7 29.9993 15V9.1533C29.9993 6.4033 27.7593 4.1533 24.9977 4.1533H24.3743L23.0627 1.5283C22.746 0.893301 21.9843 0.609967 21.346 0.864967L13.481 4.00997C11.5577 4.77997 9.99935 7.0833 9.99935 9.15497V15C9.99935 18.7 12.0127 22.6683 14.9993 24.8916V28.3333L5.45268 30.72C3.22768 31.2766 1.66602 33.2766 1.66602 35.57V40H38.3327V35.57C38.3327 33.2766 36.771 31.2766 34.546 30.72Z"
      fill={color || "#A5AEBC"}
    />
  </svg>
);

export default ProfileIcon;
